import React from 'react';

class Admin extends React.Component {

  render() {
    return (
      <div className='isAdmin'>
        <div className="md-skin">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Admin;
